import React, {
  useRef,
  cloneElement,
} from 'react'
import { connect } from 'react-redux'
import { useReactToPrint } from 'react-to-print'
import BaseTable from '../BaseTable'
import AddNewBinButton from '../OrderInfo/AddNewBinButton'
import BinNameDeletable from '../OrderInfo/BinNameDeletable'
import CurrentCount from '../OrderInfo/CurrentCount'
import CurrentCountEditable from '../OrderInfo/CurrentCountEditable'
import BinName from '../OrderInfo/BinName'

const getTableOptions = (countingMode) => {
  return {
    columns: [
      {
        name: 'Part',
        type: 'text',
        dataKey: 'partnum',
      },
      {
        name: 'Bin',
        type: 'text',
        dataKey: 'binCount',
      },
      {
        name: 'Bin Type',
        type: 'blank',
      },
      {
        name: 'DMS Count',
        type: 'text',
        dataKey: 'dmsCount',
        flexGrow: 'fg100-c',
      },
      {
        name: 'Scan Count',
        type: 'text',
        dataKey: 'scanCount',
        flexGrow: 'fg100-c',
      },
      {
        name: 'Current Count',
        type: 'component',
        component: cloneElement(<CurrentCount />),
        dataKey: 'currentCount',
        flexGrow: 'fg100-c',
      },
      {
        name: 'Price Each',
        type: 'number',
        dataKey: 'unitPrice',
        flexGrow: 'fg100-c',
      },
      {
        name: 'Assigned User',
        type: '--',
      },
      {
        name: 'Input User',
        type: '--',
      },
      {
        name: 'Status',
        type: '--',
        dataKey: 'inputUser',
      },
    ],

    childrenKey: 'bins',
    childrenColumns: [
      {
        name: 'Select',
        type: 'blank',
      },
      {
        name: 'Bin',
        type: 'component',
        component: cloneElement(<BinName />,
        ),
      },
      {
        name: 'Bin Type',
        type: 'select',
        dataKey: 'binType',
        options: [
          'primary',
        ],

        disabled: status => status === 'primary',
      },
      {
        name: 'DMS Count',
        type: '--',
        flexGrow: 'fg100-c',
      },
      {
        name: 'Scan Count',
        type: 'text',
        dataKey: 'scanCount',
        flexGrow: 'fg100-c',
      },
      {
        name: '--',
        type: 'blank',
      },
      {
        name: '--',
        type: 'blank',
      },
      {
        name: 'Assigned User',
        type: 'text',
        dataKey: 'assignedUser',
      },
      {
        name: 'Input User',
        type: 'text',
        dataKey: 'inputUser',
      },
      {
        name: 'Status',
        type: '--',
        dataKey: 'inputUser',
      },

    ],

  }
}
const tableOptions = getTableOptions()

const ComponentToPrint = (props) => {
  const data = (props.selected.printSelected ? props.selected.printSelected : props.printData.printData)
  return (
    <div className="order-info">
      <BaseTable
        className="order-info__table"
        keyProp='partnum'
        options={tableOptions}
        print={true}
        data={data === undefined || [] ? props.data : data}
      />
    </div>
  )

}

const mapStateToProps = ({ jobs: { jobList }, print: { printData, selected } }) => ({ printData, jobList, selected })

// export default ComponentToPrint

export default connect(
  mapStateToProps, null,
)(ComponentToPrint)






